"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Collapse = _styledComponents.default.div(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  height: auto;\n  max-height: ", ";\n  transition: max-height 0.25s\n    ", ";\n  overflow: hidden;\n"], ["\n  height: auto;\n  max-height: ", ";\n  transition: max-height 0.25s\n    ", ";\n  overflow: hidden;\n"])), function (props) {
  return props.maxHeight;
}, function (props) {
  return props.isOpen ? 'ease-in' : 'ease-out';
});

exports.Collapse = Collapse;
Collapse.displayName = 'CollapseWrapper';
var templateObject_1;